<template>
  <dashboard-block
    title="Рестораны за сегодня"
    :loading="loading"
    :missing="!block"
    :min-height="232"
    skeleton="table-row-divider@4"
  >
    <v-simple-table
      v-if="block && block.length"
      dense
      class="dashboard-restaurants"
    >
      <thead>
        <tr>
          <th>Ресторан</th>
          <th class="text-right">
            Заказы
          </th>
          <th class="text-right">
            Выручка
          </th>
          <th class="text-right">
            Средний чек
          </th>
          <th class="text-right">
            Дольше часа
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.key"
        >
          <td class="text--primary">
            {{ row.name }}
          </td>
          <td class="text-right">
            {{ row.orders }}
          </td>
          <td class="text-right text-no-wrap">
            {{ row.revenue }}
          </td>
          <td class="text-right text-no-wrap">
            {{ row.averageCheck }}
          </td>
          <td class="text-right text-no-wrap">
            <v-tooltip
              v-if="row.isWorst"
              top
            >
              <template #activator="{ on, attrs }">
                <span
                  class="error--text font-weight-semibold"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    size="16"
                    color="error"
                    class="me-1"
                  >{{ icons.mdiAlertCircleOutline }}</v-icon>{{ row.overHourShare }}
                </span>
              </template>
              <span>Заметно больше, чем в остальных ресторанах</span>
            </v-tooltip>

            <v-tooltip
              v-else-if="row.hint"
              top
            >
              <template #activator="{ on, attrs }">
                <span
                  class="dashboard-restaurants__uncertain"
                  v-bind="attrs"
                  v-on="on"
                >{{ row.overHourShare }}</span>
              </template>
              <span class="dashboard-restaurants__hint">{{ row.hint }}</span>
            </v-tooltip>
            <span v-else>{{ row.overHourShare }}</span>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div
      v-else
      class="text--secondary"
    >
      Сегодня заказов ещё не было.
    </div>
  </dashboard-block>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js'
import DashboardBlock from '@/views/dashboard/dashboard-block'
import { money } from '@/helpers'
import {
  fewDeliveriesHint, toCountString, toPercentString, worstOverHourKey,
} from '@/helpers/dashboard'

export default {
  name: 'DashboardRestaurants',
  components: { DashboardBlock },
  props: {
    block: { type: Array, default: null },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    icons: { mdiAlertCircleOutline },
  }),
  computed: {
    rows() {
      const restaurants = this.block || []
      const worst = worstOverHourKey(restaurants)

      return restaurants.map(row => ({
        key: row.key,
        name: row.name,
        orders: toCountString(row.orders),
        revenue: money(row.revenue),
        averageCheck: money(row.averageCheck),
        overHourShare: toPercentString(row.overHourShare),
        isWorst: row.key === worst,
        hint: fewDeliveriesHint(row),
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-restaurants {
  ::v-deep th,
  ::v-deep td {
    padding: 0 8px !important;
  }

  .dashboard-restaurants__uncertain {
    border-bottom: 1px dashed currentColor;
    cursor: help;
  }
}

.dashboard-restaurants__hint {
  opacity: 0.8;
}
</style>
